import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format size input: converts space to 'x' and only allows valid size characters
 * Example: "9.5 4" becomes "9.5x4", "8 4" becomes "8x4"
 * Only allows: numbers, 'x', decimal point, and converts space to 'x'
 */
export function formatSizeInput(value) {
  if (!value) return '';
  
  // Replace space with 'x' (multiplication sign)
  let formatted = value.replace(/\s+/g, 'x');
  
  // Remove any characters that aren't numbers, 'x', 'X', or decimal point
  formatted = formatted.replace(/[^0-9xX.]/g, '');
  
  // Convert X to lowercase x for consistency
  formatted = formatted.replace(/X/g, 'x');
  
  // Prevent multiple consecutive 'x' characters
  formatted = formatted.replace(/x+/g, 'x');
  
  // Prevent 'x' at the start
  if (formatted.startsWith('x')) {
    formatted = formatted.substring(1);
  }
  
  return formatted;
}
